import { Button } from "@mui/material";
import { FaRegEdit } from "react-icons/fa";
import moment from "moment";
import { Button as AntButton, List, Skeleton, Typography, Tooltip } from "antd";
import {
  AiOutlineCheck,
  AiOutlineInfoCircle,
  AiOutlineDelete,
} from "react-icons/ai";
import { formatCurrency } from "../../utils";

import { Container, Content } from "./styles";
import { FormModal } from "../../components/FormModal";
import { TransferenciaCustodiaRows } from "./formItems";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
import { useTransferenciaCustodia } from "../../contexts/TransferenciaCustodiaContext";

interface TransferenciaCustodiaProps { }

export const TransferenciaCustodia: React.FC<
  TransferenciaCustodiaProps
> = () => {
  const {
    add,
    edit,
    remove,
    ativo,
    ativos,
    loading,
    handleAdd,
    handleEdit,
    handleRemove,
    showFormModal,
    showDeleteModal,
    closeFormModal,
    closeDeleteModal,
    saveAtivos,
    isInvalidItem
  } = useTransferenciaCustodia();

  return (
    <Container>
      <Typography.Title level={1}>Transferência de custódia</Typography.Title>
      <Typography.Paragraph>
        Insira manualmente as informações do seu histórico de operação para os
        ativos em que foi realizada a transferência de custódia. A inserção
        manual é necessária pois não possuímos acesso às informações do seu
        histórico transacionado em outra corretora.
      </Typography.Paragraph>
      <Content>
        <Button
          className="add-button"
          variant="contained"
          color="secondary"
          onClick={handleAdd}
        >
          Adicionar ativo
        </Button>

        <List
          dataSource={ativos}
          loading={loading.get}
          itemLayout="horizontal"
          renderItem={(item, index) => (
            <List.Item
              actions={[...(isInvalidItem(item)
                ? [
                  <Tooltip
                    title={`Preencha o valor e data da compra!`}
                  >
                    <AntButton
                      type="text"
                      icon={
                        <AiOutlineInfoCircle
                          className="alert-icon"
                          size={20}
                        />
                      }
                    />
                  </Tooltip>,
                ]
                : []),
              <AntButton
                type="text"
                disabled={loading.put}
                icon={<FaRegEdit size={20} />}
                onClick={() => handleEdit(item, index)}
              />,
              <AntButton
                type="text"
                disabled={loading.delete}
                icon={<AiOutlineDelete size={20} />}
                onClick={() => handleRemove(item, index)}
              />,
              ]}
            >
              <Skeleton active title={false} loading={loading.get}>
                <List.Item.Meta
                  title={<div>{item.codigo}</div>}
                  description={
                    <>
                      <div className="list-description">

                        {item.dataCompra && (
                          <div>
                            Data de compra:{" "}
                            <strong>
                              {item.dataCompra.includes("/")
                                ? item.dataCompra
                                : moment
                                  .utc(item.dataCompra)
                                  ?.format("DD/MM/YYYY")}
                            </strong>
                          </div>
                        )}

                        {item.value &&
                          <div>
                            Custo Médio:{" "}
                            <strong>
                              {formatCurrency(item.value ?? 0)}
                            </strong>
                          </div>}
                        {/* {item.dataCompra && (
                          <div>
                            Data de compra:{" "}
                            <strong>
                              {item.dataCompra.includes("/")
                                ? item.dataCompra
                                : moment
                                    .utc(item.dataCompra)
                                    ?.format("DD/MM/YYYY")}
                            </strong>
                          </div>
                        )} */}
                        {/* <div>
                          Valor de compra (USD, Origem BRA):{" "}
                          <strong>
                            {formatCurrency(item.valorCompraUSDOrigemBRA ?? 0)}
                          </strong>
                        </div>
                        <div>
                          Valor de compra (USD, Origem EUA):{" "}
                          <strong>
                            {formatCurrency(item.valorCompraUSDOrigemEUA ?? 0)}
                          </strong>
                        </div> */}
                      </div>
                    </>
                  }
                />
              </Skeleton>
            </List.Item>
          )}
        />
        <Typography style={{ marginTop: "32px", textAlign: "right" }}>
          Lembre-se de clicar em finalizar para salvar seus dados
        </Typography>
        <Button
          size="large"
          color="secondary"
          variant="contained"
          className="final-button"
          onClick={saveAtivos}
          endIcon={<AiOutlineCheck size={18} />}
        >
          Finalizar
        </Button>
        <FormModal
          add={(at: any) => add({ ...at, orderId: ativo?.orderId })}
          edit={(at: any) => edit({ ...at, orderId: ativo?.orderId })}
          itemToEdit={ativo}
          onCancel={closeFormModal}
          visibility={showFormModal}
          rows={TransferenciaCustodiaRows(!!ativo?.id)}
          title={ativo ? "Editar ativo" : "Adicionar ativo"}
        />
        <DeleteConfirmationModal
          title="Remover ativo"
          onCancel={closeDeleteModal}
          visibility={showDeleteModal}
          setVisibility={() => closeDeleteModal()}
          onOk={() => Promise.resolve(remove(ativo!))}
          body="Você realmente quer deletar esse ativo?"
        />
      </Content>
    </Container >
  );
};
